<template>
  <div class="pt-0 md:pt-16 min-h-screen bg-front-page-background">
    <div class="max-w-xs mx-auto">
      <div class="text-center logo-container bg-front-page-background"></div>
      <div class="text-center ml-0 text-2xl front-text-color bg-front-page-background">Members Hub</div>
      <form @submit="reset" class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 mt-4">
        <div v-if="status" class="mb-4 text-sm font-semibold text-green text-center">
          {{ status }}
        </div>
        <div v-if="error" class="mb-4 text-sm font-semibold text-red text-center">
          {{ error }}
        </div>
        <div class="mb-6">
          <label class="block text-grey-darker text-sm font-bold mb-2" for="email">
            Email
          </label>
          <input class="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight"
            id="email" type="text" placeholder="Email" v-model="email" required>

          <small
            v-if="errorBag.get('email')"
            class="text-red-dark"
          >
            {{ errorBag.get('email') }}
          </small>
        </div>

        <div class="mb-6">
          <label class="block text-grey-darker text-sm font-bold mb-2" for="password">
            New Password
          </label>
          <input class="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight"
            id="password" type="password" placeholder="***********" v-model="password" required>

          <small
            v-if="errorBag.get('password')"
            class="text-red-dark"
          >
            {{ errorBag.get('password') }}
          </small>
        </div>

        <div class="mb-6">
          <label class="block text-grey-darker text-sm font-bold mb-2" for="passwordConfirmation">
            Repeat New Password
          </label>
          <input class="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker mb-3 leading-tight"
            id="passwordConfirmation" type="password" placeholder="***********" v-model="passwordConfirmation" required>
        </div>

        <div class="flex items-center justify-between">
          <button class="bg-tertiary hover:bg-tertiary text-white font-bold py-2 px-4 rounded" type="submit" :disabled="resetting" :class="{ 'opacity-50': resetting }">
            Reset Password
          </button>
          <router-link
            :to="{name: 'login'}"
            class="inline-block align-baseline font-bold text-sm text-grey hover:text-grey-darker"
          >
            Back to login
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import ErrorBag from '@/ErrorBag'

export default {
  name: 'login',

  data () {
    return {
      resetting: false,
      email: null,
      password: null,
      passwordConfirmation: null,
      error: null,
      status: null,
      errorBag: new ErrorBag()
    }
  },
  mounted () {
    document.querySelector('#page-wrap').classList.remove('fit-page')
    document.querySelector('#page-wrap').style.transform = ''
  },
  methods: {
    ...mapActions(['bootSystem']),

    reset (e) {
      e.preventDefault()
      this.error = null
      this.errorBag.clear()
      this.resetting = true

      axios
        .post(process.env.VUE_APP_ROOT_API + '/password/reset', {
          email: this.email,
          password: this.password,
          password_confirmation: this.passwordConfirmation,
          token: this.$route.params.token
        })
        .then(response => {
          if (response.data.error) {
            this.error = response.data.error
          } else {
            this.status = response.data.status
          }

          this.resetting = false
        })
        .catch(error => {
          this.resetting = false
          this.errorBag.store(error.response.data)
        })
    }
  }
}
</script>
